import React from "react";

const WhyChooseUs = () => {
  const features = [
    {
      title: "High Success Rate",
      description:
        "95% of our students successfully clear their exams with structured preparation.",
      stat: "95% Success",
    },
    {
      title: "Large Student Community",
      description:
        "Join thousands of students preparing together on one trusted platform.",
      stat: "10K+ Students",
    },
    {
      title: "Flexible Learning",
      description:
        "Learn anytime, anywhere at your own pace with full access to courses.",
      stat: "24/7 Access",
    },
    {
      title: "Quality Study Material",
      description:
        "Expert-designed notes, mock tests and previous year question papers.",
      stat: "500+ Materials",
    },
    {
      title: "Quick Doubt Resolution",
      description:
        "Get your doubts resolved quickly by experienced mentors.",
      stat: "< 2 Hours",
    },
    {
      title: "Affordable Pricing",
      description:
        "High quality education at affordable fees suitable for every student.",
      stat: "From ₹299",
    },
  ];

  return (
    <div className="bg-[#1d3a80] py-4 px-2">
      {/* SECTION TITLE */}
      <h2 className="text-white text-center text-3xl font-bold mb-6">
        Why Choose Us
      </h2>

      {/* WHITE CONTAINER */}
      <div className="bg-[#f5f7fb] rounded-3xl p-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 p-5
                         hover:shadow-sm transition"
            >
              {/* STAT */}
              <div className="text-sm font-semibold text-[#1f4fa3] mb-2">
                {item.stat}
              </div>

              {/* TITLE */}
              <h3 className="text-[16px] font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="text-[13px] text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
